import styled from 'styled-components';

export const NotificationList = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme['white-primary']};

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;
export const NotificationItem = styled.div<{ isRead: boolean }>`
  width: 100%;
  padding: 15px 20px;
  background-color: ${({ theme, isRead }) => (isRead ? theme['white-primary'] : theme['orange-tertiary'])};

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 5px;
`;

export const NotificationAlert = styled.div`
  width: 100%;
  padding: 15px 20px;
  background-color: ${({ theme }) => theme['white-primary']};

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const NoData = styled.div`
  width: 100%;
  height: 90dvh;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;

  img {
    width: 103px;
    height: 93px;
    mix-blend-mode: luminosity;
  }
`;
